module.exports = __webpack_public_path__ + "static/activebarre-studio-a7943491a2d38c77d272d022634cc577.jpg";